import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import enCommon from "./locales/en/common.json";
import enAuth from "./locales/en/auth.json";
import enHome from "./locales/en/home.json";
import enDocuments from "./locales/en/documents.json";
import enWizard from "./locales/en/wizard.json";
import enTemplates from "./locales/en/templates.json";
import enLiquid from "./locales/en/liquid.json";
import enPdfPreview from "./locales/en/pdfPreview.json";
import deCommon from "./locales/de/common.json";
import deAuth from "./locales/de/auth.json";
import deHome from "./locales/de/home.json";
import deDocuments from "./locales/de/documents.json";
import deWizard from "./locales/de/wizard.json";
import deTemplates from "./locales/de/templates.json";
import deLiquid from "./locales/de/liquid.json";
import dePdfPreview from "./locales/de/pdfPreview.json";

const resources = {
    en: {
        common: enCommon,
        auth: enAuth,
        home: enHome,
        documents: enDocuments,
        wizard: enWizard,
        templates: enTemplates,
        liquid: enLiquid,
        pdfPreview: enPdfPreview,
    },
    de: {
        common: deCommon,
        auth: deAuth,
        home: deHome,
        documents: deDocuments,
        wizard: deWizard,
        templates: deTemplates,
        liquid: deLiquid,
        pdfPreview: dePdfPreview,
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        // debug: true, // Set to true for development debugging

        // Language detection options
        detection: {
            order: ["navigator", "htmlTag"],
            //    if caching is needed, uncomment this code:
            //    caches: ['localStorage'], lookupLocalStorage: 'i18nextLng',

            // next two lines are used to handle langauges like 'de-DE'
            lookupFromPathIndex: 0,
            convertDetectedLanguage: (lng: string) => lng.split("-")[0].toLowerCase(),
        },

        // Namespace and key separator
        ns: ["common", "auth", "home", "documents", "wizard", "templates", "liquid", "pdfPreview"],
        defaultNS: "common",
        keySeparator: ".",
        nsSeparator: ":",

        interpolation: {
            escapeValue: false, // React already escapes values
        },

        // Only use German if browser language starts with 'de'
        supportedLngs: ["en", "de"],
    });

export default i18n;
